export const queryConditionName = {
  uid_list: '帐号ID',
  uname: '帐号名称',
  user_id: '运营人员',
  master_user_id: '主要运营人员',
  design_user_id: '设计师',
  industry_id_list: '广告主行业',
  begin_date: '开户日期',
  buying_type: '账户类型',
  customer_status: '账户状态',
  isCollectAdvertiser: '是否收藏',
  auto_transfer_valid: '自动转账',
  balance_status: '余额状态',
  customized_label_list: '自定义筛选条件',
};
export default {
  queryConditionName,
};
